module.exports = __webpack_public_path__ + "img/46.57b6446b.jpg";